import { Component, Input } from '@angular/core';
import { SelectorCategory } from '@nx-ng/types';
import { iconHeaderMap } from './icon-header.config';

@Component({
  selector: 'nx-ng-icon-header',
  templateUrl: './icon-header.component.html',
  styleUrls: ['./icon-header.component.scss'],
})
export class IconHeaderComponent {
  @Input()
  category?: SelectorCategory;

  get icon(): string {
    let icon: string | undefined;
    if (this.category) {
      icon = iconHeaderMap[this.category].icon;
    }
    return icon ?? '';
  }

  get label(): string {
    let label: string | undefined;
    if (this.category) {
      label = iconHeaderMap[this.category].label;
    }
    return label ?? '';
  }
}
